// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag","disabled":"Tag_disabled","label":"Tag_label","deleteButtonWrapper":"Tag_deleteButtonWrapper","empty":"Tag_empty","deleteButton":"Tag_deleteButton"};